//Package Dependencies
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

//forcing git commit

//Helper functions
import { domReady } from "./domready";

const getEnv = () => {
  //env set from a query param
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  if(params.env === 'test' || params.env === 'staging'){return 'staging'}
  if(params.env === 'prod'){return 'prod'}
  if(window.env === 'staging'){return 'staging'} //env set in the branding profile
  return 'staging'
}
const env = getEnv();
const App = require(`./App`).default;

console.log(env, 'enviroment')

//========================================
//    RF HEADER AND FOOTER CONTAINERS
//========================================
domReady(() => {
  const headerEntrypoint = ReactDOM.createRoot(
    document.querySelector(".rf-org-header-container")
  );
  headerEntrypoint.render(
        <BrowserRouter>
          <Routes>
            <Route path="/flow/intel/innovation2022/*" element={<App env={env} />} />
            <Route path="/*" element={<App env={env} />} />
          </Routes>
        </BrowserRouter>
  );
}, ".rf-org-header-container");

domReady(() => {
  document.querySelector("html").style.cssText = "height:100%;";
  document.querySelector("body").style.cssText =
    "display:flex; flex-direction:column; height:100%;";
  document.querySelector(".rf-org-footer-container").classList.add("mt-auto");
}, ".rf-org-footer-container");
